<template>
	<b-form-checkbox
		id="checkbox-1"
		v-model="inputData"
		name="checkbox-1"
		class="dynamic-check"
		@change="$emit('select-value', inputData)"
	>
		{{ label }}
	</b-form-checkbox>
</template>

<script>
export default {
	name: "Checkbox",
	props: {
		type: String,
		label: String,
		mandatory: Boolean,
		placeholder: String,
		id: String,
		vmodel: {
			validator: function () {
				return true;
			},
		},
	},
	watch: {
		vmodel(newValue) {
			console.log(newValue, "neeeeeeeeeeeeeeee");

			this.inputData = newValue;
		},
	},
	data() {
		return {
			inputData: false,
		};
	},
	created() {
		console.log(this.vmodel, "vmodellllllllll");

		if (this.vmodel) {
			this.inputData = this.vmodel;
			this.$emit("select-value", this.inputData);
		}
	},
};
</script>
<style></style>
